module.exports = __webpack_public_path__ + "img/New PACI Flow AR - Enable Authentication - 7.a1fe3554.png";